import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useUpdateTemplateNode = (handleModalClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_TEMPLATE_NODE],
    (data) => ApiService.updateTemplateNode(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_TEMPLATE);
        handleModalClose();
        toast.success("Template Node updated successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useUpdateTemplateNode;
